<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        <a
          href="#"
          @click.prevent="$router.push({ name: 'student-profile' })"
          class="mr-2"
        >
          <i class="fas fa-arrow-left"></i>
        </a>
        {{
          $t('school.academic.operation.profile_mgt.studentProfile.pageTitle')
        }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t(
              'school.academic.operation.profile_mgt.studentProfile.pageTitle'
            ),
            href: '/student-profiles',
          },
          {
            text: $t(
              'school.academic.operation.profile_mgt.studentProfile.cardByClass'
            ),
            active: true,
          },
        ]"
      />
    </div>
    <div class="row">
      <div class="col-md-3">
        <ts-card>
          <ts-card-wrapper>
            <ts-loading-banner :loading="loading">
              <form>
                <fieldset>
                  <legend>
                    {{
                      $t(
                        'school.academic.operation.profile_mgt.studentProfile.criteria'
                      )
                    }}
                  </legend>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.subProgram'
                        )
                      }}</label>
                      <a-select
                        style="width: 100%"
                        v-model.number="model.acps_id"
                        :options="sub_programs"
                        @change="fetchClass"
                      ></a-select>
                      <div class="validate" v-if="errors.has('acps_id')">
                        {{ errors.first('acps_id') }}
                      </div>
                    </div>
                  </div>
                  <div class="row form-group">
                    <div class="col-md-12">
                      <label class="required">{{
                        $t(
                          'school.academic.operation.profile_mgt.studentProfile.className'
                        )
                      }}</label>
                      <ts-loading-banner :loading="class_fetching">
                        <a-select
                          style="width: 100%"
                          v-model.number="model.class_id"
                          :options="class_lists"
                          @change="fetchStudent"
                        ></a-select>
                      </ts-loading-banner>
                      <div class="validate" v-if="errors.has('class_id')">
                        {{ errors.first('class_id') }}
                      </div>
                    </div>
                  </div>
                  <ts-loading-banner :loading="fetching">
                    <div
                      id="container"
                      class="form-group overflow-auto"
                      style="max-height: 47vh; min-height: 30vh"
                    >
                      <table
                        id="list"
                        class="table table-hover ui-table ts-table"
                      >
                        <thead>
                          <tr>
                            <th class="text-center">
                              <ts-checkbox
                                @change="selectAll"
                                v-model="checked_all"
                              ></ts-checkbox>
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{
                                $t(
                                  'school.academic.operation.profile_mgt.studentProfile.cardNumber'
                                )
                              }}
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{
                                $t(
                                  'school.academic.operation.profile_mgt.studentProfile.studentName'
                                )
                              }}
                            </th>
                            <th class="ts-whitespace-no-wrap">
                              {{
                                $t(
                                  'school.academic.operation.profile_mgt.studentProfile.sex'
                                )
                              }}
                            </th>
                          </tr>
                          <tr>
                            <th colspan="4">
                              <input
                                type="text"
                                class="form-control"
                                :placeholder="$t('search')"
                                v-model="searchStudentText"
                              />
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(record, index) in availableStudents"
                            :key="index"
                          >
                            <td class="text-center">
                              <ts-checkbox
                                :value="record.student_id"
                                v-model="model.selectedStudent"
                                @change="
                                  model.selectedStudent.length ==
                                  student_lists.length
                                    ? (checked_all = true)
                                    : (checked_all = false)
                                "
                              ></ts-checkbox>
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.card_number }}
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.full_name_en }}
                            </td>
                            <td class="ts-whitespace-no-wrap">
                              {{ record.gender }}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </ts-loading-banner>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="radio radio-css radio-inline">
                        <input
                          v-model="side"
                          type="radio"
                          id="front"
                          :value="'front'"
                        />
                        <label for="front">
                          {{
                            $t(
                              'school.academic.operation.profile_mgt.studentProfile.front'
                            )
                          }}
                        </label>
                      </div>
                      <div class="radio radio-css radio-inline">
                        <input
                          v-model="side"
                          type="radio"
                          id="back"
                          :value="'back'"
                        />
                        <label for="back">
                          {{
                            $t(
                              'school.academic.operation.profile_mgt.studentProfile.back'
                            )
                          }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12 text-right">
                      <ts-button
                        color="primary"
                        @click.prevent="preview"
                        :waiting="printing"
                        :disabled="model.selectedStudent.length <= 0"
                        >{{ $t('preview') }}</ts-button
                      >
                    </div>
                  </div>
                </fieldset>
              </form>
            </ts-loading-banner>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-md-9">
        <ts-card>
          <ts-card-wrapper>
            <form>
              <fieldset>
                <legend>
                  {{
                    $t(
                      'school.academic.operation.profile_mgt.studentProfile.previewCard'
                    )
                  }}
                </legend>
                <ts-preview-pdf v-model="printing" :src="src" />
              </fieldset>
            </form>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'cardByClass',
  data() {
    return {
      loading: false,
      printing: false,
      class_fetching: false,
      fetching: false,
      checked_all: false,
      src: '',
      errors: new Errors(),
      sub_programs: [],
      class_lists: [],
      student_lists: [],
      searchStudentText: '',
      side: 'front',
      model: {
        acps_id: null,
        class_id: null,
        selectedStudent: [],
      },
    }
  },
  computed: {
    availableStudents() {
      return this.student_lists.filter((s) => {
        if (this.searchStudentText.trim() !== '') {
          return (
            s.full_name_en
              .toLowerCase()
              .includes(this.searchStudentText.toLowerCase().trim()) ||
            s.card_number.includes(
              this.searchStudentText.toLowerCase().trim()
            ) ||
            s.gender
              .toLowerCase()
              .includes(this.searchStudentText.toLowerCase().trim())
          )
        }

        return this.student_lists
      })
    },
  },
  created() {
    this.fetchSubProgram()
  },
  methods: {
    ...mapActions('studentProfile', [
      'getSubProgram',
      'getClass',
      'getStudent',
    ]),
    fetchSubProgram() {
      this.loading = true
      this.getSubProgram()
        .then((response) => {
          this.sub_programs = response.data.map((el) => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    fetchClass(acps_id) {
      this.model.class_id = null
      this.class_lists = []
      this.student_lists = []
      this.model.selectedStudent = []
      this.class_fetching = true
      this.getClass(acps_id)
        .then((response) => {
          this.class_lists = response.data.map((el) => ({
            value: el.class_id,
            label: el.class_name,
          }))
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.class_fetching = false
        })
    },
    fetchStudent(class_id) {
      this.model.selectedStudent = []
      this.fetching = true
      this.getStudent({
        class_id: class_id,
      })
        .then((response) => {
          this.student_lists = []
          this.student_lists = response.data
        })
        .catch((error) => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching = false
        })
    },
    selectAll(e) {
      if (e) {
        this.model.selectedStudent = []
        this.student_lists.map((el) => {
          this.model.selectedStudent.push(el.student_id)
          this.checked_all = true
        })
      } else {
        this.model.selectedStudent = []
      }
    },
    preview() {
      this.printing = true
      this.$store
        .dispatch('studentProfile/printCard', {
          student_id_list: this.model.selectedStudent,
          side: this.side,
          acps_id: this.model.acps_id,
        })
        .then((response) => {
          this.$toasted.success(response.message)
          this.printing = false
          this.src = response.url
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.printing = false
        })
    },
  },
}
</script>
<style scoped>
#list > thead > tr > th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  padding: 7px;
  border-bottom: none !important;
  z-index: 10;
}
#list > tbody > tr > td {
  padding: 3px;
  vertical-align: bottom;
}
</style>
